module.exports = __webpack_public_path__ + "static/media/case-final-exam.360d2fbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-final-exam.jpg
// module id = 80
// module chunks = 3